'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addSlash = addSlash;
exports.getUrl = getUrl;
exports.getLocale = getLocale;
exports.getObj = getObj;
var isClient = typeof window !== 'undefined';
var net = isClient ? require('@ali/network') : {};

/**
 * 末尾加斜杠
 *
 * @export
 * @param {string} url 链接字符串
 * @return {string} 保证字符串末尾有斜杠
 */
function addSlash(url) {
  if (typeof url !== 'string') return '/';
  if (url.slice(-1) !== '/') url += '/';
  return url;
}
/**
 * 校验是否一个正确的 url
 *
 * @param {String} str 链接字符串
 * @return {Boolean} 布尔值
 */
exports.isUrl = function (str) {
  if (!str) return false;
  var matcher = /^(?:\w+:)?\/\/([^\s\.]+\.\S{2}|localhost[\:?\d]*)\S*$/;
  return matcher.test(str);
};

/**
 * 首页多语言切换url拼接
 *
 * @param {String} val 链接字符串 edit为跳转到编辑页面，index跳转到首页
 * @return {string} 加了公参的链接
 */
function getUrl(val) {
  var _location = location,
      search = _location.search,
      origin = _location.origin,
      pathname = _location.pathname;

  var queryObj = '';
  var url = '';
  if (search !== '') {
    // 解析 query 参数
    queryObj = net.parseObject(search) || '';
  }
  if (queryObj.lange) {
    delete queryObj.lange;
  }
  if (queryObj === '' || JSON.stringify(queryObj) === '{}') {
    url = origin + pathname + '?lange=' + val;
  } else {
    url = origin + pathname + '?' + net.parseQuery(queryObj) + '&lange=' + val;
  }
  return url;
  // return net.ucParam(url);
}

/**
 * 直接在 window.__BROCCOLI_EXT_CONFIG__.__intl__.messages 获取语言
 *
 * @export
 * @param {string} localeKey 文案标识
 * @return {string} 对应文案
 */
function getLocale(localeKey) {
  if (typeof window === 'undefined') return;
  var intl = getObj(window, '__BROCCOLI_EXT_CONFIG__.__intl__.messages');
  if (!intl) return '';

  var value = getObj(intl, localeKey);

  if (!value) return localeKey;
  return value;
}

/**
 * getObj 通过 key string 获取对象的属性值
 * @usage getObj(obj, 'a.b.c')
 *
 * @param  {Object} obj         对象
 * @param  {String} [keyStr=''] key string
 * @return {String}             不存在则返回 undefined
 */
function getObj(obj) {
  var keyStr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var ARRAY_PATH_REGEXP = /\[\s*(\d+)\s*\]/;
  var keyArr = keyStr.split('.');
  for (var i = 0; i < keyArr.length; i++) {
    var key = keyArr[i];
    if (!obj) {
      return;
    }
    var matchArrayPath = key.match(ARRAY_PATH_REGEXP);
    if (matchArrayPath && matchArrayPath[1]) {
      obj = obj[key.replace(ARRAY_PATH_REGEXP, '')][matchArrayPath[1]];
    } else {
      obj = obj[key];
    }
  }
  return obj;
}